"use client";

import { useState } from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Quote, X, Star } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { FormProvider } from "@/integrations/forms/FormProvider";
export default function Otzyvi() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [rating, setRating] = useState(0);
  const {
    ref: ref1,
    isVisible: isVisible1
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: ref2,
    isVisible: isVisible2
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: ref3,
    isVisible: isVisible3
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: ref4,
    isVisible: isVisible4
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const testimonials = [{
    name: "Мария Петрова",
    text: "Всеки ден нещо ново и вкусно! Цените са много добри и обслужването е бързо и приятелско. Определено моят любим избор за обяд.",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1504672/img/maria_petrova_testimonial.png"
  }, {
    name: "Иван Георгиев",
    text: "Заведението е много удобно за бързо хранене, и качеството на храната е на много високо ниво. Препоръчвам топло!",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1504672/img/ivan_georgiev_testimonial.png"
  }, {
    name: "Елена Димитрова",
    text: "Организирахме фирмено събитие при тях и всичко беше перфектно! Менюто беше разнообразно и всички колеги останаха доволни.",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1504672/img/elena_dimitrova_testimonial.png"
  }, {
    name: "Стоян Николов",
    text: "Модерно заведение, вкусна храна и приятелски персонал. Връщам се отново и отново!",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1504672/img/stoyan_nikolov_testimonial.png"
  }];
  const refs = [ref1, ref2, ref3, ref4];
  const visibilities = [isVisible1, isVisible2, isVisible3, isVisible4];
  const onSubmit = async (data: any) => {
    try {
      console.log("Submitting review data:", data);
      const response = await fetch("/api/reviews", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(data)
      });
      if (!response.ok) {
        throw new Error("Failed to submit review");
      }
      setIsModalOpen(false);
      setRating(0);
    } catch (error) {
      console.error("Error submitting review:", error);
      setIsModalOpen(false);
      setRating(0);
    }
  };
  return <section id="отзиви" className="bg-background py-16 md:py-24 relative">
      <div className="container">
        <div className="text-center mb-12">
          <h2 className="text-foreground mb-4">Отзиви</h2>
          <p className="text-muted-foreground max-w-2xl mx-auto">Вижте какво споделят наши клиенти за своя опит в Миш‑Маш /интерпред/</p>
        </div>

        <div className="flex flex-col items-center gap-8 max-w-3xl mx-auto">
          {testimonials.map((testimonial, i) => <div key={i} data-index={i} ref={refs[i]} className={`w-full transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${visibilities[i] ? "opacity-100 translate-y-0 rotate-0" : "opacity-0 translate-y-3 rotate-1"}`}>
              <Card className="card group cursor-pointer">
                <CardContent className="flex flex-col md:flex-row items-center gap-6 p-8">
                  <div className="flex-1 text-center md:text-left">
                    <Quote className="size-8 text-sky-900 mb-3 mx-auto md:mx-0" />
                    <p className="text-foreground leading-relaxed mb-4 group-hover:text-foreground/90 transition-colors duration-[var(--duration-medium)]">
                      {testimonial.text}
                    </p>
                    <p className="font-display font-semibold text-foreground">
                      {testimonial.name}
                    </p>
                  </div>
                </CardContent>
              </Card>
            </div>)}
        </div>

        <div className="text-center mt-12">
          <Button className="btn-primary shadow-soft hover:shadow-medium" onClick={() => setIsModalOpen(true)}>
            Оставете отзив
          </Button>
        </div>
      </div>

      {isModalOpen && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/40 backdrop-blur-sm animate-in fade-in duration-200">
          <div className="absolute inset-0" onClick={() => setIsModalOpen(false)} />
          <Card className="relative w-full max-w-lg bg-white shadow-clay-hover animate-in zoom-in-95 duration-200">
            <CardContent className="p-8">
              <div className="flex justify-between items-center mb-6">
                <h3 className="text-2xl font-display font-bold text-foreground">Оставете отзив</h3>
                <Button variant="ghost" size="icon" onClick={() => setIsModalOpen(false)} className="rounded-full">
                  <X className="size-6 text-muted-foreground" />
                </Button>
              </div>

              <FormProvider onSubmit={onSubmit} formId="review_form" sectionName="testimonials">
                <form onSubmit={e => {
              e.preventDefault();
              const formData = new FormData(e.currentTarget);
              const data = Object.fromEntries(formData.entries());
              onSubmit(data);
            }}>
                  <input type="hidden" name="wp_form_active" value="true" />
                  <div className="space-y-4">
                    <div className="space-y-2">
                      <label className="text-sm font-medium text-foreground">Име</label>
                      <input name="name" type="text" placeholder="Вашето име" required className="w-full px-4 py-2 rounded-lg bg-[#F9F9F9] border-b-2 border-transparent focus:border-secondary focus:outline-none transition-all" />
                    </div>

                    <div className="space-y-2">
                      <label className="text-sm font-medium text-foreground">Имейл</label>
                      <input name="email" type="email" placeholder="your@email.bg" required className="w-full px-4 py-2 rounded-lg bg-[#F9F9F9] border-b-2 border-transparent focus:border-secondary focus:outline-none transition-all" />
                    </div>

                    <div className="space-y-2">
                      <label className="text-sm font-medium text-foreground">Оценка</label>
                      <div className="flex gap-2">
                        <input type="hidden" name="rating" value={rating} />
                        {[1, 2, 3, 4, 5].map(star => <Button key={star} type="button" variant="ghost" size="sm" onClick={() => setRating(star)} className={`p-1 transition-colors h-auto hover:text-primary-active ${star <= rating ? "text-primary" : "text-foreground"}`}>
                            <Star className={`size-6 ${star <= rating ? "fill-current" : ""}`} />
                          </Button>)}
                      </div>
                    </div>

                    <div className="space-y-2">
                      <label className="text-sm font-medium text-foreground">Коментар</label>
                      <textarea name="comment" rows={4} placeholder="Споделете вашето преживяване..." required className="w-full px-4 py-2 rounded-lg bg-[#F9F9F9] border-b-2 border-transparent focus:border-secondary focus:outline-none transition-all resize-none" />
                    </div>

                    <div className="pt-4">
                      <Button type="submit" className="w-full btn-primary">
                        Изпрати отзив
                      </Button>
                    </div>
                  </div>
                </form>
              </FormProvider>
            </CardContent>
          </Card>
        </div>}
    </section>;
}